<template>
  <div id="deviceIn">
    <el-row>
      <el-col :span="24" class="check data-title">
        <p>查询条件</p>
      </el-col>
    </el-row>
    <el-row class="input-list">
      <el-form ref="form" :model="form" label-width="85px" label-position="right" class="form">
        <el-form-item label="策略名称：" prop="dev2" class="form1">
          <el-input type="text" v-model="form.dev2" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row class="data-list">
      <div class="data-list-detail data-title">
		<p>数据列表</p>
		<p>
		  <el-button type="primary" size="mini">添加策略</el-button>
		</p>
	  </div>  
      <div>
		<el-table :data="tableData" border :style="`height:${tableHeight}px;`">
          <el-table-column prop="name" label="策略名称"> </el-table-column>
          <el-table-column prop="goal" label="目标负荷"></el-table-column>
          <el-table-column prop="analysis" label="策略解析"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> <span>|</span>
              <el-button type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
		tableHeight:"",
        form: {
          dev2: '',
        },
        tableData: [{
          analysis: '调高空调出水温度5℃，降低冷却泵点击频率。',
          name: "01夏季空调调频策略",
          goal: '20000kw',
        }, {
          analysis: '根据工作时间安排，节约非工作时间插座功率。',
          name: "02照明控制策略",
          goal: '5000kw',
        }, {
          analysis: '',
          name: "20000kw",
          goal: '20000kw',
        }, {
          analysis: '04',
          name: "02照明控制策略",
          goal: '20000kw',
        }, {
          analysis: '444',
          name: "02照明控制策略",
          goal: '20000kw',
        }]
      }
	},
	mounted() {
      	this.tableHeight = document.documentElement.clientHeight - 250;
    }
  }

</script>
<style scoped>
	#deviceIn{
		color: #fff;
	}
	.check{
		height: 40px;
		line-height: 38px;
	}
	.form1{
    	padding: 0 60px;
	}
	.data-list-detail{
		width: 100%;
		height: 40px;
		line-height: 38px;
	}
	.data-list-detail p:first-of-type{
		display: inline-block;
	}
	.data-list-detail p:last-of-type{
		float: right;
		margin-right: 15px;
	}
</style>